// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"01bf866a","430":"9dd26f68","481":"6ddcd9f7","547":"eae9a932","581":"e355efa6","628":"6cc9351a","632":"810cb66d","657":"843c8ae1","688":"0bf59ce1","783":"bfe7866f","833":"9a57675d","899":"1f426bdd","948":"227f7cd2"}[chunkId] + ".chunk.js";
};